// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WysiwygImage--floatLeft,.WysiwygImage--floatRight{margin:1rem 0}@media(min-width:768px){.WysiwygImage--floatLeft,.WysiwygImage--floatRight{margin:0 0 .25rem}.WysiwygImage--floatLeft{float:left;margin-right:1.5rem}.WysiwygImage--floatRight{float:right;margin-left:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
